import { Holiday } from '../holidays';

export const MEXICO_HOLIDAYS: Record<number, Holiday[]> = {
    2024: [
        { name: "Año Nuevo", date: new Date(2024, 0, 1) },
        { name: "Constitución", date: new Date(2024, 1, 5) },
        { name: "Benito Juárez", date: new Date(2024, 2, 18) },
        { name: "Labor Day", date: new Date(2024, 4, 1) },
        { name: "Independence", date: new Date(2024, 8, 16) },
        { name: "Revolution", date: new Date(2024, 10, 18) },
        { name: "Christmas", date: new Date(2024, 11, 25) }
    ],
    2025: [
        { name: "Año Nuevo", date: new Date(2025, 0, 1) },
        { name: "Constitución", date: new Date(2025, 1, 3) },
        { name: "Benito Juárez", date: new Date(2025, 2, 17) },
        { name: "Labor Day", date: new Date(2025, 4, 1) },
        { name: "Independence", date: new Date(2025, 8, 16) },
        { name: "Revolution", date: new Date(2025, 10, 17) },
        { name: "Christmas", date: new Date(2025, 11, 25) }
    ],
    2026: [
        { name: "Año Nuevo", date: new Date(2026, 0, 1) },
        { name: "Constitución", date: new Date(2026, 1, 2) },
        { name: "Benito Juárez", date: new Date(2026, 2, 16) },
        { name: "Labor Day", date: new Date(2026, 4, 1) },
        { name: "Independence", date: new Date(2026, 8, 16) },
        { name: "Revolution", date: new Date(2026, 10, 16) },
        { name: "Christmas", date: new Date(2026, 11, 25) }
    ]
};
